import { VerifyPhoneNumberResult } from 'enums/FlowNextResults';
import { reapply } from 'thunks';

type BorrowerFields = {
  firstName: string;
  lastName: string;
  credential?: string;
};

type ReapplyAction = ReturnType<typeof reapply>;

export const nextStepAfterPrefill = async (
  dispatchWithUnwrap: (action: ReapplyAction) => Promise<unknown>,
  sessionToken: string | undefined,
  borrowerFields: BorrowerFields,
  emailPresent?: boolean,
): Promise<VerifyPhoneNumberResult> => {
  if (sessionToken && borrowerFields.firstName && borrowerFields.lastName) {
    try {
      await dispatchWithUnwrap(
        reapply({
          sessionToken,
          ...borrowerFields,
        }),
      );
      return VerifyPhoneNumberResult.CanReapply;
    } catch {
      // No earlier application. Show the prefilled identity instead.
    }
  }

  return emailPresent ? VerifyPhoneNumberResult.PrefillWithEmail : VerifyPhoneNumberResult.PrefillNeedsEmail;
};
